<h2>Input Basic Examples</h2>

<div class="input-grid">
	<div class="input-column">
		<span class="label">Input solo</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter text..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter text...'})" />
	</div>

	<div class="input-column">
		<span class="label">Con label</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter your name..."
			label="Full Name"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter your name...', label: 'Full Name'})" />
	</div>

	<div class="input-column">
		<span class="label">Con helper text</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter password..."
			label="Password"
			helperText="Must be at least 8 characters"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter password...', label: 'Password', helperText: 'Must be at least 8 characters'})" />
	</div>
</div>

<h2>Input with Icons</h2>

<div class="input-grid">
	<div class="input-column">
		<span class="label">Icono a la izquierda</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter your email..."
			label="Email"
			icon="envelope"
			iconPosition="left"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter your email...', label: 'Email', icon: 'envelope', iconPosition: 'left'})" />
	</div>

	<div class="input-column">
		<span class="label">Icono a la derecha</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter email..."
			label="Email"
			icon="envelope"
			iconPosition="right"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter email...', label: 'Email', icon: 'envelope', iconPosition: 'right'})" />
	</div>

	<div class="input-column">
		<span class="label">Input completo</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Enter your email..."
			label="Email Address"
			icon="envelope"
			iconPosition="left"
			helperText="We'll never share your email"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Enter your email...', label: 'Email Address', icon: 'envelope', iconPosition: 'left', helperText: 'We will never share your email'})" />
	</div>
</div>

<h2>Input Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Large input..."
			label="Large Input"
			icon="envelope"
			iconPosition="left"
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Large input...', label: 'Large Input', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Medium input..."
			label="Medium Input"
			icon="envelope"
			iconPosition="left"
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Medium input...', label: 'Medium Input', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Small input..."
			label="Small Input"
			icon="envelope"
			iconPosition="left"
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Small input...', label: 'Small Input', size: 'small'})" />
	</div>
</div>

<h2>Input States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Normal input..."
			label="Normal State"
			icon="envelope"
			iconPosition="left"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Normal input...', label: 'Normal State'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-input
			[formControl]="disabledControl"
			placeholder="Disabled input..."
			label="Disabled State"
			icon="envelope"
			iconPosition="left"
			[disabled]="true"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledControl', placeholder: 'Disabled input...', label: 'Disabled State', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Error input..."
			label="Error State"
			icon="envelope"
			iconPosition="left"
			[error]="true"
			errorMessage="This field is required"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'inputControl', placeholder: 'Error input...', label: 'Error State', error: true, errorMessage: 'This field is required'})" />
	</div>
</div>

<h2>Input Sizes Comparison (without icons)</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Large..."
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({placeholder: 'Large...', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Medium..."
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({placeholder: 'Medium...', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px)</span>
		<app-input
			[formControl]="inputControl"
			placeholder="Small..."
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({placeholder: 'Small...', size: 'small'})" />
	</div>
</div>
